import React from 'react';

export const validationStyling: React.CSSProperties = {
  color: '#bf1650',
};
